import * as v from 'valibot';
// Note: these cookie consent groups are always present
const REQUIRED_CONSENT_GROUP_IDS = new Set([
    "C0001" /* OneTrustConsentGroupIds.STRICTLY_NECESSARY */,
    "C0003" /* OneTrustConsentGroupIds.FUNCTIONAL */,
]);
const OneTrustConsentEventSchema = v.object({
    detail: v.array(v.string()),
});
export const safeParseOneTrustConsentEvent = (event) => {
    const result = v.safeParse(OneTrustConsentEventSchema, event);
    return result.success ? result.output.detail : [];
};
export const isCATemplate = () => {
    var _a, _b, _c;
    const state = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.OneTrust) === null || _a === void 0 ? void 0 : _a.getGeolocationData) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.state;
    return typeof state === 'string' && state.trim().toUpperCase() === 'CA';
};
export const isOptingOut = ({ currentGroups, previousGroups, }) => {
    // Always ignore initial load
    if (previousGroups === null)
        return false;
    // when only required cookie consent groups are present,
    // it means user is opting out (initially or re-opting out)
    const isOnlyRequiredGroups = currentGroups.size === REQUIRED_CONSENT_GROUP_IDS.size &&
        [...REQUIRED_CONSENT_GROUP_IDS].every((id) => currentGroups.has(id));
    if (isOnlyRequiredGroups)
        return true;
    // Otherwise, check if any cookie consent groups were removed in this update.
    return [...previousGroups].some((id) => !currentGroups.has(id));
};
/**
 * Adds an event listener to the window that listens for OneTrust cookie consent changes and
 * invokes a callback when the user opts out of cookies.
 *
 * This subscribes to the `OneTrustGroupsUpdated` event which fires
 * whenever cookie consent preferences are updated via the banner or preference center.
 *
 * @param callbacks.onOptOut - Callback invoked when the user opts out of consent categories
 *
 * Follows the implementation in the marketing-site:
 * https://github.com/hellowisp/marketing-site/blob/339bbfcfb96b6af0c107c4af3abda82e88d617d6/hooks/useOneTrustConsentListener.ts
 */
export const initOneTrustConsentListener = ({ onOptOut, }) => {
    let previousActiveGroups = null;
    const handleConsentChange = (event) => {
        const parsedGroups = safeParseOneTrustConsentEvent(event);
        // Skip if parsing fails (should never happen) or for non-California
        // consent groups should always at least contain REQUIRED_CONSENT_GROUP_IDS
        if (parsedGroups.length === 0 || !isCATemplate()) {
            return;
        }
        const currentGroups = new Set(parsedGroups);
        const previousGroups = previousActiveGroups;
        if (isOptingOut({ currentGroups, previousGroups })) {
            onOptOut();
        }
        previousActiveGroups = currentGroups;
    };
    window.addEventListener('OneTrustGroupsUpdated', handleConsentChange);
};
